<template>
  <div class="container d-flex flex-column min-vh-100 mb-0">
    <div class="row justify-content-center flex-grow-1 align-items-center">
      <div class="col-10 col-md-7 col-lg-5 col-xl-4 mx-auto">
        <div id="card-black" class="card mt-0">
          <div id="card-black" class="card-header p-0 overflow-hidden">
            <div class="header-container d-flex justify-content-center align-items-center">
              <img :src="brandLogo" :alt="brandName + ' Logo'" class="logo-image" :class="brandLogoClass" />
            </div>
          </div>
          <div class="card-body">
            <Form role="form" class="text-start mt-3" :validation-schema="schema" @submit="handleReset">
              <div class="mb-3">
                <material-input-field id="newPassword" v-model="password" type="password"
                  :label="$t('users.password') || 'New Password'" name="newPassword" variant="static" />
              </div>
              <div class="mb-3">
                <material-input-field id="confirmPassword" v-model="confirmation" type="password"
                  :label="$t('users.confirmPassword') || 'Confirm Password'" name="confirmPassword" variant="static" />
              </div>
              <div class="text-center">
                <material-button class="my-4 mb-2" variant="gradient" :color="brandButtonColor" full-width type="submit">
                  {{ $t('common.resetpassword') }}
                </material-button>
              </div>
            </Form>
          </div>
          <div class="card-footer text-center pt-0 px-sm-4 px-1 mt-4">
            <p class="mb-2 mx-auto">
              <router-link :to="{ name: 'Login' }" class="text-white font-weight-bold">
                {{ $t('sidebar.login') }}
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer />
</template>

<script>
import branding from "../branding";
import api from "../services/api";
import { getApiErrorMessage } from "../utils/apiError";
import AppFooter from "@/examples/Footer.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import { Form } from "vee-validate";
import * as Yup from 'yup';

export default {
  name: "PasswordReset",
  components: {
    AppFooter,
    MaterialInputField,
    MaterialButton,
    Form
  },
  data() {
    return {
      brandLogo: branding.loginLogo,
      brandName: branding.name,
      brandLogoClass: branding.loginLogoClass,
      brandButtonColor: branding.buttonColor,
      password: '',
      confirmation: '',
      userId: '',
      resetCode: '',
      schema: Yup.object().shape({
        newPassword: Yup.string()
          .required("Password is a required input")
          .min(8, "Password must have at least 8 characters")
          .matches(/[a-z]/, "Must contain at least one lowercase letter")
          .matches(/[A-Z]/, "Must contain at least one uppercase letter")
          .matches(/[0-9]/, "Must contain at least one number")
          .matches(/[^A-Za-z0-9]/, "Must contain at least one special character"),
        confirmPassword: Yup.string()
          .required("Confirm password is a required input")
          .oneOf([Yup.ref('newPassword')], 'Passwords do not match'),
      }),
    };
  },
  created() {
    const forgotten = this.$route.query.forgotten;
    if (forgotten === 'true') {
      this.userId = this.$route.query.userId;
      this.resetCode = this.$route.query.resetCode;
    } else {
      this.userId = this.$route.params.userId || this.$route.query.userId;
      this.resetCode = this.$route.params.resetCode || this.$route.query.resetCode;
    }
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    async handleReset() {
      try {
        await api.post('/identity/ResetPassword', {
          userId: this.userId,
          token: this.resetCode,
          password: this.password
        });
        this.$toast.success(this.$t('common.resetPasswordSuccess'), { timeout: 2000 });
        this.$router.push({ name: 'Login' });
      } catch (error) {
        console.error('Password reset failed:', error); // eslint-disable-line no-console
        const identifier = error?.response?.data?.[0]?.identifier
          || error?.response?.data?.errors?.[0]?.identifier;
        if (identifier === 'ResetLinkExpired') {
          this.$toast.error(this.$t('common.resetLinkExpired'), { timeout: 0 });
          this.$router.push({ name: 'PasswordForgot' });
          return;
        }
        this.$toast.error(getApiErrorMessage(this.$t, error), { timeout: 0 });
      }
    }
  },
};
</script>
<style scoped>
#card-black {
  background: #27293d;
}

.container {
  padding-top: 0;
  padding-bottom: 0;
}

.header-container {
  min-height: 200px;
  background-color: transparent;
  padding: 24px 20px;
  overflow: hidden;
}

.logo-image {
  width: 80%;
  max-width: 360px;
  height: auto;
  object-fit: contain;
  display: block;
}

.logo-image.logo-tolspor {
  transform: scale(2);
}

.logo-image.logo-golfspor {
  width: 100%;
  max-width: 100%;
  transform: scale(1.8);
}

@media (max-width: 767.98px) {
  .header-container {
    min-height: 140px;
    padding: 16px;
  }
}

:deep(.input-group-static .form-control) {
  padding-top: 12px;
  padding-bottom: 10px;
}

:deep(.form-label) { color: #fff !important; }
:deep(.form-control) { color: #fff !important; background-color: transparent !important; }
:deep(.form-control::placeholder) { color: rgba(255, 255, 255, 0.7) !important; }
:deep(.form-control:focus) { color: #fff !important; }
</style>
